__turbopack_context__.v({
  "quoteListWrapper": "HH07Dq_quoteListWrapper",
});
